import Vue from 'vue'
import { baseURL } from './axios'
import VueApollo from 'vue-apollo'
import { HttpLink } from 'apollo-link-http'
import ApolloClient from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'accessToken'

// Provide the URL to the API server.
const httpEndpoint = baseURL + 'graphql'

const getHeaders = () => {
  const headers = {}
  const token = window.sessionStorage.getItem(AUTH_TOKEN) || window.localStorage.getItem(AUTH_TOKEN)
  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return headers
}

//Http link
const httpLink = new HttpLink({
  uri: httpEndpoint,
  fetch,
  headers: getHeaders()
})

// Config
const apolloClientOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of apolloClientOptions.
  link: httpLink,

  // Override default cache
  cache: new InMemoryCache()
}

// export ApolloClient for execute queries
export const apolloClient = new ApolloClient(apolloClientOptions)

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  return new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only'
      }
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        '%cError',
        'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
        error.message
      )
    }
  })
}
